import {
  appStoreAnalyticsKey,
  type AppStoreOs,
} from '@pkg/modular-blocks/frontend/appStores';
import { logger } from '@pkg/logger';
import { ampli } from '@pkg/analytics-helper/src/ampli';

/** Provide Amplitude download_app tracking to shared App Store badge components. */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(appStoreAnalyticsKey, {
    trackDownloadApp(appOs: AppStoreOs) {
      try {
        ampli.track({
          event_type: 'download_app',
          user_properties: {
            app_os: appOs,
          },
        });
      } catch (error) {
        logger.error('[app-store-analytics] Amplitude download_app failed', error);
      }
    },
  });
});
